import {ACTION_GET_USER_INFO} from '../../constant/eventbus'
import {url_without_ticket} from './ticket'


export function login() {
  setTimeout(() => {
    if (gact.is_h5 || gact.debug) {
      logout()
      const loginurl = `${gact.config.h5_login}?pagename=ACT_D&clocation=1&source=${window.gact.source}&ftype=5&return_url= ${encodeURIComponent(url_without_ticket(window.location.href))}`;
      console.log(loginurl)
      // return;
      window.location.href = loginurl
    } else {
      MgtvApi.login(data => {
        const userInfo = data && JSON.parse(data);
        // window.$bus.$emit(ACTION_GET_USER_INFO, userInfo.ticket);
      });
    }
  }, 300);
}


export function logout() {
  setTimeout(() => {
    if (gact.is_h5) {
      window.location.href = `${gact.config.h5_logout}?pagename=ACT_D&clocation=1&source=${window.gact.source}&ftype=5&return_url= ${encodeURIComponent(url_without_ticket(window.location.href))}`
    }
  }, 300);
}




// WEBPACK FOOTER //
// ./src/tools/mgtv/login.js